import { type ReactNode } from 'react';
import { Chip } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { type MaterialDtoType } from '@/api';
import { cn } from '@/utils';
import { MaterialTypeBadge } from './MaterialTypeBadge';

/**
 * Material info header component
 * Displays: Title + Type Badge + Chip (horizontally aligned with gap-sm)
 *
 * @description
 * Matches Figma design (node 28129:16312 "Number")
 * - Layout: flex with gap-sm (12px)
 * - Contains title, type badge, and status chip
 */
export interface MaterialInfoHeaderProps {
  type: MaterialDtoType;
  allowReopenDuringPlay: boolean;
  rightSlot?: ReactNode;
}
export const MaterialInfoHeader = ({
  type,
  allowReopenDuringPlay,
  rightSlot
}: MaterialInfoHeaderProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full flex-wrap items-center gap-sm px-lg" data-sentry-component="MaterialInfoHeader" data-sentry-source-file="MaterialInfoHeader.tsx">
      {/* Left: Title + Type Badge */}
      <div className="flex min-h-px min-w-px shrink-0 items-center gap-sm mobile-lg:flex-1">
        <p className="shrink-0 text-heading-sm-bold text-default">
          {t('common:header.learningMaterial.button')}
        </p>
        <MaterialTypeBadge type={type} data-sentry-element="MaterialTypeBadge" data-sentry-source-file="MaterialInfoHeader.tsx" />
      </div>

      {/* Right: Chip */}
      <Chip size="sm" className={cn('rounded-xl border border-alternative px-xs py-3xs text-body-sm-semibold text-alternative shrink-0')} data-sentry-element="Chip" data-sentry-source-file="MaterialInfoHeader.tsx">
        {allowReopenDuringPlay ? t('common:learningMaterial.allowReopenDuringPlayChip') : t('common:learningMaterial.NotAllowReopenDuringPlayChip')}
      </Chip>

      {rightSlot}
    </div>;
};